import { environment } from '@vshosting/cdn/env';

import { provideClientZoneApi } from './user-base';

export const CORE_PROVIDERS = [
  provideClientZoneApi(environment.clientZoneApi)
] as const;
